import { Unit } from '../components/ServiceItem';

export type Contact = {
  id: string;
  type: 'E-mail' | 'Colaboradores Einstein' | 'Público Geral' | 'Corporativo';
  value: string;
};

export type RichUnit = {
  id: string;
  active: boolean;
  name: string;
  companyCode: string;
  contacts: Contact[];
  address: {
    cep: string;
    name: string;
    number: string;
    block_building: string;
    complement: string;
    city: string;
    state: string;
    neighborhood: string;
  };
  workHours: {
    start: string;
    end: string;
    different: {
      start: string;
      end: string;
    };
    weekdays: {
      monday: boolean;
      tuesday: boolean;
      wednesday: boolean;
      thursday: boolean;
      friday: boolean;
      is_24h: boolean;
    };
    weekends: {
      saturday: boolean;
      sunday: boolean;
      is_24h: boolean;
    };
    holiday: {
      hours: {
        start: string;
        end: string;
      };
      is_24h: boolean;
      is_holiday: boolean;
    };
    id: string;
  };
  locations: {
    id: string;
    name: string;
    description: string;
    observations: string;
    service_hours: string | null;
  }[];
  img_url: string;
  id_sgh: string;
  cnes: string;
  coordinates: {
    lat: string;
    lng: string;
  };
  facilities: {
    id: string;
    name: string;
    createdAt: string;
    updatedAt: string;
    businessUnitId: string;
  }[];
};

const isPhoneContact = (contact: Contact): boolean =>
  contact.type === 'Público Geral' || contact.type === 'Colaboradores Einstein' || contact.type === 'Corporativo';

export const convertRichUnitToUnit = (richUnit: RichUnit): Unit => {
  return {
    id: richUnit.id,
    active: richUnit.active,
    name: richUnit.name,
    cnpj: richUnit.companyCode,
    id_sgh: richUnit.id_sgh,
    img_url: richUnit.img_url,

    address: richUnit.address.name,
    address_complement: richUnit.address.complement,
    address_number: richUnit.address.number,
    block_building: richUnit.address.block_building,
    cep: richUnit.address.cep,
    city: richUnit.address.city,
    state: richUnit.address.state,
    neighborhood: richUnit.address.neighborhood,
    phone: richUnit.contacts.find(contact => contact.type === 'Público Geral')?.value,
    phoneList: richUnit.contacts.filter(isPhoneContact), // só existe para unidades da rota /branch do catálogo

    business_unit_work_hour_id: richUnit.workHours.id,
    business_unit_work_hour: {
      id: richUnit.workHours.id,

      sunday: richUnit.workHours.weekends.sunday,
      saturday: richUnit.workHours.weekends.saturday,
      is_24h_weekends: richUnit.workHours.weekends.is_24h,

      monday: richUnit.workHours.weekdays.monday,
      tuesday: richUnit.workHours.weekdays.tuesday,
      wednesday: richUnit.workHours.weekdays.wednesday,
      thursday: richUnit.workHours.weekdays.thursday,
      friday: richUnit.workHours.weekdays.friday,
      is_24h_weekdays: richUnit.workHours.weekdays.is_24h,

      work_hour_start: richUnit.workHours.start,
      work_hour_end: richUnit.workHours.end,

      holiday_work_hour_start: richUnit.workHours.holiday.hours.start,
      holiday_work_hour_end: richUnit.workHours.holiday.hours.end,

      different_work_hour_start: richUnit.workHours.different.start,
      different_work_hour_end: richUnit.workHours.different.end,

      holiday: richUnit.workHours.holiday.is_holiday,
      is_24h_holiday: richUnit.workHours.holiday.is_24h
    }
  } as Unit;
};
